import React, { useState} from 'react';
import BarcodeReader from 'react-barcode-reader'

function Focus() {
  const [result, setResult]=useState('No result');
   
 function handleScan(data){
  setResult(data);    
  }
  function handleError(err){
    console.error(err)
  }

     function handleChange(e) {
        const { minLength, value, id } = e.target;
        const [fieldName, fieldIndex] = id.split("-");
  
        // Check if they hit the max character length
        if (value.length >= minLength) {
          // Check if it's not the last input field
          if (parseInt(fieldIndex, 10) < 3) {
            // Get the next input field
            const nextSibling = document.querySelector(
              `input[id=ssn-${parseInt(fieldIndex, 10) + 1}]`
            );
  
            // If found, focus the next field
            if (nextSibling !== null) {
              nextSibling.focus();
            }
          }
        }
  
     }  
  
    return (
      <>
      <BarcodeReader
          onError={handleError}
          onScan={handleScan}
          />
        <p>{result}</p>

        <input
          type="text"
          id="ssn-1"
          minLength={3}
          value={result}
          onChange={handleChange} />
        <input
          type="text"
          id="ssn-2"          
          minLength={2}
          onChange={handleChange} />
        <input
          type="text"
          id="ssn-3"
          minLength={4}
          onChange={handleChange} />
      </>
    );
  };
//}

export default Focus;